(function () {
  "use strict";

  var t = {
    720: function _(t, e) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var r = function () {
        function t() {}

        return t.prototype.setClient = function (t) {
          this.client = t;
        }, t.prototype.getMethod = function (t, e) {
          return void 0 === e && (e = this), this.client.getMethod(t, e).bind(this);
        }, t;
      }();

      e.default = r;
    },
    175: function _(t, e, r) {
      var o = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.Provider = void 0;
      var i = o(r(720));
      e.Provider = i.default;
    }
  },
      e = {},
      r = function r(o) {
    var i = e[o];
    if (void 0 !== i) return i.exports;
    var n = e[o] = {
      exports: {}
    };
    return t[o].call(n.exports, n, n.exports, r), n.exports;
  }(175);

  module.exports = r;
})();